import { Button, Group } from "@mantine/core";
import { useState } from "react";
import type { ProjectMinimal } from "../../../utils/backend-types";
import { useShouldShowStaffView } from "../../StaffViewToggle/useShouldShowStaffView";
import { NotAccessableModal } from "../../StructureView/NotAccessableModal/NotAccessableModal";
import { CreateProjectModal } from "./CreateProjectModal/CreateProjectModal";

interface CreateProjectButtonProps {
  onCreateProject: (projectId: string) => void;
}

function CreateProjectButton({ onCreateProject }: CreateProjectButtonProps) {
  const [openModal, setOpenModal] = useState<"noAccess" | "createModal" | null>(
    null
  );
  const { shouldShowStaffView } = useShouldShowStaffView();

  function toggleModal() {
    if (!shouldShowStaffView) {
      setOpenModal("noAccess");
    } else {
      if (openModal === "createModal") {
        setOpenModal(null);
      } else {
        setOpenModal("createModal");
      }
    }
  }

  function handleClickSave(project: ProjectMinimal) {
    onCreateProject(project.id);
    toggleModal();
  }

  return (
    <Group className="CreateProjectButton">
      <Button
        color="primary"
        fz="sm" // because this button is nested under "paper-header-font" it inherits 1.3 em which is too big.
        variant={shouldShowStaffView ? "filled" : "default"}
        onClick={toggleModal}
      >
        Neues Projekt erstellen
      </Button>
      <CreateProjectModal
        isOpen={openModal === "createModal"}
        toggle={toggleModal}
        onClickSave={handleClickSave}
      />
      {openModal === "noAccess" && (
        <NotAccessableModal
          text={
            "Diese Option steht derzeit nicht zur Verfügung," +
            " da Sie nicht über die entsprechenden Berechtigungen verfügen." +
            " Bitte wenden Sie sich an das Support-Team: "
          }
          onClose={() => setOpenModal(null)}
        />
      )}
    </Group>
  );
}

export { CreateProjectButton };
